import { render } from "./size-selector.vue?vue&type=template&id=081d8034"
import script from "./size-selector.vue?vue&type=script&lang=js"
export * from "./size-selector.vue?vue&type=script&lang=js"

import "./size-selector.vue?vue&type=style&index=0&id=081d8034&lang=scss"

import exportComponent from "/Users/andrewamistad/Sites/lyle-and-scott/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__